/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function ForecastRequestDataItemFromJSON(json) {
    return ForecastRequestDataItemFromJSONTyped(json, false);
}
export function ForecastRequestDataItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        historyDataExpression: json['historyDataExpression'],
        targetRows: json['targetRows'],
    };
}
export function ForecastRequestDataItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        historyDataExpression: value.historyDataExpression,
        targetRows: value.targetRows,
    };
}
